import React from 'react'
import KPI from '../features/cashflow/key-performance-indicator/KPI'

const KPIs = () => {
  return (
    <>
    <KPI/>
    </>
  )
}

export default KPIs